import getPageName from "./getPageName";
import lazyLoadBlock from "./lazyloadBlock";
import initReviewsSlider from "./sliders.js/init-reviews-slider";

const reviews = () => {
  const reviewsWrap = document.querySelector(".reviews__cards-wrapper");

  if (!reviewsWrap) {
    return;
  }

  function parseReviews() {
    $.ajax({
      type: "GET",
      url: "/files/reviews.json",
    }).then(function (regions) {
      regions.forEach(function (el) {
        if (el.url == getPageName()) {
          createReviewsCard(el.data);
        }
      });
    });
  }

  function createReviewsCard(data) {
    let content = '';

    data.forEach((item, i) => {
      if (item.video) {
        content += `
        <div class="reviews__card reviews__card-video swiper-slide">
          <div class="reviews__card-wrap reviews__card-wrap-video video-${item.modal}">
            <video class="reviews__card-videoFrame" loop="loop" muted="muted" preload="none" poster=${item.poster} src=${item.src} playsinline="" class="reviews-students__item-media">
            </video>
            <div class="cardBottom__right">
              <a data-fslightbox="review-${i}" href="${item.video}" class="cardBottom__link"></a>
              <p class="cardBottom__p">Смотреть&nbsp;отзыв</p>
            </div>
            <div class="reviews__card-bottom cardBottom">
              <p class="cardBottom__left">${item.name}</p>
              <p class="cardBottom__left_profession">${item.profession}</p>
            </div>
          </div>
        </div>
    `;
      } else {
        content += `
        <div class="reviews__card swiper-slide">
          <div class="reviews__card-wrap">
              <div class="reviews__card-block">
                <div class="reviews__card-head">
                  <img src="${
                    item.img ? item.img : "/img/tgu/reviews/icon.svg"
                  }" loading="lazy" alt="">
                  <h4>${item.name}</h4>
                </div>
                <p class="reviews__card-text">${item.text}</p>
              </div>
              <div class="reviews__card-rating">
                  <p>${item.rating} / 5</p>
                  <div class="reviews__card-rating__icons ${item.star}"></div>
              </div>
          </div>
        </div>
    `;
      }
    });

    reviewsWrap.innerHTML = content;

    setTimeout(() => {      
      initReviewsSlider();
    }, 50);
  }
  
  lazyLoadBlock(parseReviews);
};

export default reviews;
